module.exports = __webpack_public_path__ + "img/益视说明书_17.d1a887f3.png";